import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {NavBar} from "antd-mobile";
import {AppOutline, HistogramOutline, UnorderedListOutline} from "antd-mobile-icons";
import {Item, PathNavigationTabBar} from "../../delivery/components/PathNavigationTabBar";
import {Outlet, useNavigate, useLocation} from "react-router-dom";
import MenuIconWithBadge from "../../delivery/components/MenuIconWithBadge";
import {MapModeIcon} from "assets/icons";
import {DspPath} from "../../../enums/DeliveryNavigatePathEnum";
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import DspUserMenuDrawer from "../components/DspUserMenuDrawer";

type DspLayoutProps = {
    children?: React.ReactNode;
    title: string;
}

const DspLayout: React.FC<DspLayoutProps> = ({children, title}) => {
    const { t } = useTranslation();
    const [menuVisible, setMenuVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const dspItems: Item[] = [
        {
            path: DspPath.DELIVERY_DSP_HOME,
            icon: <AppOutline/>,
            label: t('pages.dsp.navigation.home')
        },
        {
            path: DspPath.DELIVERY_DSP_OPERATIONAL,
            icon: <HistogramOutline />,
            label: t('pages.dsp.navigation.operationData')
        },
        {
            path: DspPath.DELIVERY_DSP_TASK,
            icon: <UnorderedListOutline />,
            label: t('pages.dsp.navigation.deliveryTasks')
        }
    ];

    const handleOpenMenu = () => {
        setMenuVisible(true);
    };

    const handleCloseMenu = () => {
        setMenuVisible(false);
    };

    const handleMapModeClick = () => {
        // 从 sessionStorage 获取选中的日期
        const selectedDate = sessionStorage.getItem('selectedTaskDate');
        navigate(DspPath.DELIVERY_DSP_DELIVERY_TASK_MAP, {
            state: { taskDate: selectedDate }
        });
    };

    // 检查当前是否在DSP派送任务页面（需要显示地图图标）
    const isDspDeliveryTaskPage = location.pathname.startsWith(DspPath.DELIVERY_DSP_TASK);

    return (
        <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
            {/* 用户菜单抽屉 */}
            <DspUserMenuDrawer
                visible={menuVisible}
                onClose={handleCloseMenu}
            />

            {/* 顶部导航栏 - 固定 */}
            <div {...getNavBarContainerStyle('flex-none sticky top-0 z-10 bg-white shadow-sm')}>
                <NavBar
                    backIcon={<MenuIconWithBadge count={0}/>}
                    onBack={handleOpenMenu}
                    right={isDspDeliveryTaskPage ? (
                        <div className="flex items-center justify-end w-full" onClick={handleMapModeClick}>
                            <MapModeIcon width={24} height={24} />
                        </div>
                    ) : null}>
                        {title}
                </NavBar>
            </div>

            {/* 中间内容区域 - 弹性滚动 */}
            <div className="flex-1 overflow-y-auto">
                {children || <Outlet/>}
            </div>

            {/* 底部导航 - 固定 */}
            <div className="flex-none sticky bottom-0 z-10 bg-white border-t border-gray-200">
                <PathNavigationTabBar items={dspItems}/>
            </div>
        </div>
    );
};

export default DspLayout;

